
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { ALERT_COLORS } from '@/store/base'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseFormSelect from '@/components/BaseFormSelect.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import ContactFaq from '@/components/ContactFaq.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import { HOME_PATH } from '@/router/routes'

export default defineComponent({
  components: { LayoutsAuth, BaseFormSubmit, BaseFormSelect, BaseAlert, LayoutsAuthWidth, ContactFaq },
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const dialogVisible = ref(false)
    const initialValues = computed(() => {
      return {
        contact_category_id: 1,
        subject: '',
        body: ''
      }
    })

    const schema = yup.object({
      contact_category_id: yup.number().required(),
      subject: yup.string().required().max(255),
      body: yup.string().required().max(5000),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: contact_category_id } = useField<number>('contact_category_id')
    const { value: subject } = useField<string>('subject')
    const { value: body } = useField<string>('body')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/contact', values)
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('contact.success')], persistent: true, color: ALERT_COLORS.info })
          router.push(HOME_PATH)
        })
        .finally(() => {
          btnDisabled.value = false
          dialogVisible.value = false
        })
    })

    const onDialog = handleSubmit(values => {
      dialogVisible.value = true
    })

    const selectCategory = () => {
      return Array.isArray(store.state.contact.category) ? store.state.contact.category.find(category => category.value === contact_category_id.value)?.text : ''
    }

    onMounted(() => {
      store.dispatch('contact/fetchCategory')
    })

    return {
      t,
      errors,
      contact_category_id,
      subject,
      body,
      onSubmit,
      onDialog,
      btnDisabled,
      store,
      dialogVisible,
      selectCategory
    }
  },
})
